var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "circle-outline",
    cx: 128,
    cy: 128,
    r: 125
  })), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M128,78.815c16.02,0 17.92,0.06 24.25,0.35c16.26,0.74 23.855,8.455 24.595,24.595c0.29,6.325 0.345,8.225 0.345,24.245c0,16.025 -0.06,17.92 -0.345,24.245c-0.745,16.125 -8.32,23.855 -24.595,24.595c-6.33,0.29 -8.22,0.35 -24.25,0.35c-16.02,0 -17.92,-0.06 -24.245,-0.35c-16.3,-0.745 -23.855,-8.495 -24.595,-24.6c-0.29,-6.325 -0.35,-8.22 -0.35,-24.245c0,-16.02 0.065,-17.915 0.35,-24.245c0.745,-16.135 8.32,-23.855 24.595,-24.595c6.33,-0.285 8.225,-0.345 24.245,-0.345Zm0,-10.815c-16.295,0 -18.335,0.07 -24.735,0.36c-21.79,1 -33.9,13.09 -34.9,34.9c-0.295,6.405 -0.365,8.445 -0.365,24.74c-0,16.295 0.07,18.34 0.36,24.74c1,21.79 13.09,33.9 34.9,34.9c6.405,0.29 8.445,0.36 24.74,0.36c16.295,-0 18.34,-0.07 24.74,-0.36c21.77,-1 33.91,-13.09 34.895,-34.9c0.295,-6.4 0.365,-8.445 0.365,-24.74c-0,-16.295 -0.07,-18.335 -0.36,-24.735c-0.98,-21.77 -13.085,-33.9 -34.895,-34.9c-6.405,-0.295 -8.45,-0.365 -24.745,-0.365Zm-0,29.19c-17.015,-0 -30.81,13.795 -30.81,30.81c-0,17.015 13.795,30.815 30.81,30.815c17.015,0 30.81,-13.795 30.81,-30.815c-0,-17.015 -13.795,-30.81 -30.81,-30.81Zm-0,50.81c-11.045,0 -20,-8.95 -20,-20c-0,-11.045 8.955,-20 20,-20c11.045,0 20,8.955 20,20c-0,11.05 -8.955,20 -20,20Zm32.03,-59.225c-3.98,0 -7.205,3.225 -7.205,7.2c-0,3.975 3.225,7.2 7.205,7.2c3.975,-0 7.195,-3.225 7.195,-7.2c-0,-3.975 -3.22,-7.2 -7.195,-7.2Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.821f57cda3d90e87b7f3dfc81b1f9808.svg";
export { ForwardRef as ReactComponent };